module.exports = __webpack_public_path__ + "img/20.e68f223e.jpg";